import api from '@/api'
import baseJs from '@/transformer/base'
import { getArrangedDate } from '@/transformer/datespan'

const getDefaultState = () => {
  return {
    careers: [],
    career_types: [],
    listApiStatus: baseJs.getApiStatusEmpty()
  }
}

const mutations = {
  setCareers(state, careers) {
    state.careers = [...careers]
  },
  setCareer_types(state, careerTypes) {
    state.career_types = [...careerTypes]
  },
  setListApiStatus(state, apiStatus) {
    state.listApiStatus = { ...apiStatus }
  }
}

const actions = {
  async getCareers({ commit }) {
    commit('setListApiStatus', baseJs.getApiStatusEmpty())
    try {
      const res = await api.career.list()
      commit('setCareers', res.list)
      commit('setCareer_types', res._careerTypes)
      commit('setListApiStatus', baseJs.getApiStatusSuccess())
      return Promise.resolve()
    } catch (err) {
      commit('setListApiStatus', { ...baseJs.getErrorStatus(err) })
      return Promise.reject(err)
    }
  }
}

const getters = {
  /**
   * ポートフォリオの編集画面での表示用に、日時の形式を日本語表記に変更する
   * @return array 経歴の配列
   */
  careerList(state, getters) {
    return state.careers.map((e) => {
      return {
        id: e.id,
        name: e.name,
        position: e.position,
        type: e.type,
        typeLabel: getters.careerType(Number(e.type)),
        started_at: getArrangedDate(e.started_at),
        ended_at: getArrangedDate(e.ended_at)
      }
    })
  },
  careerTypesForSelect(state) {
    return baseJs.getSelectionsByArray(state.career_types)
  },
  career: (state) => (id) => {
    const newCareer = {
      id: 0,
      user_id: 0,
      name: '',
      position: '',
      type: 0,
      started_at: null,
      ended_at: null
    }
    const career = state.careers.find((career) => career.id === id)
    if (!career) {
      return newCareer
    }

    return {
      id: career.id,
      user_id: career.user_id,
      name: career.name,
      position: career.position,
      type: career.type,
      started_at: career.started_at ? new Date(career.started_at) : null,
      ended_at: career.ended_at ? new Date(career.ended_at) : null
    }
  },
  careerType: (state) => (id) => {
    const careerType = state.career_types.find((careerType) => careerType.id === id)
    if (careerType && careerType.name) {
      return careerType.name
    }
    return '未登録'
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters
}
